<template>
  <div>
    <div class="flex content-center mb-6">
      <StoreSelector class="w-1/4" @updatedSelectedStoreId="fetchIndex({ page: 1 })" />
    </div>
    <SearchToolbar
      :available-filters="availableFilters"
      :selected-filters="selectedFilters"
      :placeholder="$t('SearchProducts')"
      :initial-keywords="keywords"
      @update-keyword-search="updateKeywordSearch"
      @update-filter-search="updateFilterSearch"
    />
    <div class="flex justify-between mt-5">
      <PriceFilter />
      <div class="flex space-x-4">
        <ProductCategoryBulkUpdateButton
          :selected-products="selectedProducts"
          :businessVerticals="businessVerticalIndex"
        />
        <ProductBulkActionButtons :selected-products="selectedProducts" />
        <SecondaryButton @click="fetchIndex({ page: getCurrentPage })">Actualiser</SecondaryButton>
      </div>
    </div>
  </div>
</template>

<script>
import ProductBulkActionButtons from "@/views/products/list/menu/actions/ProductBulkActionButtons.vue";
import StoreSelector from "@/views/products/list/menu/selectors/StoreSelector.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { SearchToolbar } from "@estaly/ui";
import PriceFilter from "@/components/products/PriceFilter.vue";
import { SecondaryButton } from "@estaly/ui";
import ProductCategoryBulkUpdateButton from "@/views/products/list/content/actions/ProductCategoryBulkUpdateButton.vue";

export default {
  components: {
    ProductCategoryBulkUpdateButton,
    SecondaryButton,
    PriceFilter,
    SearchToolbar,
    StoreSelector,
    ProductBulkActionButtons,
  },
  props: ["selectedProducts"],

  watch: {
    selectedStore(newValue) {
      if (newValue) this.fetchBusinessVerticalsIndex({ storeId: [newValue.id], enabled: true });
    },
  },

  computed: {
    ...mapState("products", ["keywords", "currentPage", "selectedFilters", "productTypes", "selectedStore"]),
    ...mapState("businessVerticals", { businessVerticalIndex: "index" }),
    ...mapGetters("stores", { storesIndex: "getIndex" }),

    availableFilters() {
      return {
        approvalStatus: [
          { label: "En cours d'approbation", value: "to_be_approved" },
          { label: "Approuvé", value: "approved" },
          { label: "Refusé", value: "refused" },
        ],
        contractStatus: [
          { label: "A matcher", value: "pending" },
          { label: "Matché", value: "matched" },
          { label: "Non assurable", value: "non_warrantable" },
        ],
        enabled: [
          { label: "Activé", value: true },
          { label: "Non activé", value: false },
        ],
        productType: this.productTypes,
        category: this.businessVerticalIndex.map((businessVertical) => ({
          label: businessVertical.translatedCategory,
          value: businessVertical.category,
        })),
      };
    },
  },

  methods: {
    ...mapActions("products", ["fetchIndex", "updateFilter", "updateSearch"]),
    ...mapActions("businessVerticals", {
      fetchBusinessVerticalsIndex: "fetchIndex",
    }),
    updateKeywordSearch(keywords) {
      this.updateSearch({ keywords: keywords, page: this.currentPage });
    },
    updateFilterSearch(filterName, filterOptions) {
      this.updateFilter({
        filterName: filterName,
        filterOptions: filterOptions,
        page: this.currentPage,
      });
    },
  },
};
</script>
